import { useContext } from 'react';
import { ShellAppContext } from './ShellAppContext';

/**
 * useShellAppContext — consume the shell app context from any component inside
 * the ShellAppContextProvider tree.
 *
 * Returns the context value.  When called outside the provider the default
 * (all-null) value is returned so components can still render in degraded mode.
 *
 * @returns {import('./ShellAppContext').ShellAppContextValue}
 */
export function useShellAppContext() {
  return useContext(ShellAppContext);
}
